import { View } from 'react-native';
import { Catcher } from 'system/catcher';
import { questionModuleQuery, useModule } from 'system/structure-modules';
import { useNotifyHostAboutDimensionOnLayoutHandler } from 'util/iframe-messaging';

export default function SpaceTeaserScreen() {
    const onLayout = useNotifyHostAboutDimensionOnLayoutHandler();
    const { QuestionTeaser } = useModule(questionModuleQuery);

    return (
        <View onLayout={onLayout}>
            <Catcher>
                <QuestionTeaser />
            </Catcher>
        </View>
    );
}
